
import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Orders() {
  const [activeTab, setActiveTab] = useState('all');

  const orders = [
    {
      id: 'ORD-2024-001',
      date: '2024-01-15',
      status: 'delivered',
      total: 85,
      items: 5,
      image: 'https://public.readdy.ai/ai/img_res/2df58ac7c9e3de7576e23b0bbb16a4f4.jpg'
    },
    {
      id: 'ORD-2024-002',
      date: '2024-01-18',
      status: 'shipping',
      total: 120,
      items: 8,
      image: 'https://readdy.ai/api/search-image?query=Fresh%20milk%20bottle%20dairy%20product%2C%20high-quality%20product%20photography%2C%20isolated%20on%20clean%20white%20background%2C%20centered%20composition%2C%20professional%20studio%20lighting%2C%20minimalist%20aesthetic%2C%20white%20and%20blue%20packaging%2C%20detailed%20texture%2C%20sharp%20focus%2C%20commercial%20grocery%20product%20shot%2C%20simple%20and%20clean&width=200&height=200&seq=ordergro2&orientation=squarish'
    },
    {
      id: 'ORD-2024-003',
      date: '2024-01-20',
      status: 'processing',
      total: 65,
      items: 4,
      image: 'https://readdy.ai/api/search-image?query=Fresh%20bread%20loaf%20bakery%20product%2C%20high-quality%20product%20photography%2C%20isolated%20on%20clean%20white%20background%2C%20centered%20composition%2C%20professional%20studio%20lighting%2C%20minimalist%20aesthetic%2C%20golden%20brown%20color%2C%20detailed%20texture%2C%20sharp%20focus%2C%20commercial%20grocery%20product%20shot%2C%20simple%20and%20clean&width=200&height=200&seq=ordergro3&orientation=squarish'
    },
    {
      id: 'ORD-2024-004',
      date: '2024-01-22',
      status: 'cancelled',
      total: 45,
      items: 3,
      image: 'https://readdy.ai/api/search-image?query=Fresh%20red%20apples%20fruit%2C%20high-quality%20product%20photography%2C%20isolated%20on%20clean%20white%20background%2C%20centered%20composition%2C%20professional%20studio%20lighting%2C%20minimalist%20aesthetic%2C%20bright%20red%20color%2C%20detailed%20texture%2C%20sharp%20focus%2C%20commercial%20grocery%20product%20shot%2C%20simple%20and%20clean&width=200&height=200&seq=ordergro4&orientation=squarish'
    }
  ];

  const getStatusInfo = (status: string) => {
    switch (status) {
      case 'delivered':
        return { text: 'تم التوصيل', color: 'text-green-600', bg: 'bg-green-50', icon: 'ri-checkbox-circle-fill' };
      case 'shipping':
        return { text: 'قيد الشحن', color: 'text-blue-600', bg: 'bg-blue-50', icon: 'ri-truck-fill' };
      case 'processing':
        return { text: 'قيد المعالجة', color: 'text-orange-600', bg: 'bg-orange-50', icon: 'ri-time-fill' };
      case 'cancelled':
        return { text: 'ملغي', color: 'text-red-600', bg: 'bg-red-50', icon: 'ri-close-circle-fill' };
      default:
        return { text: 'غير معروف', color: 'text-gray-600', bg: 'bg-gray-50', icon: 'ri-question-fill' };
    }
  };

  const filteredOrders = activeTab === 'all' 
    ? orders 
    : orders.filter(order => order.status === activeTab);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-blue-50 pb-20" dir="rtl">
      {/* Header */}
      <div className="fixed top-0 w-full bg-white/80 backdrop-blur-lg shadow-sm z-50">
        <div className="px-4 py-3 flex items-center justify-between">
          <Link to="/profile" className="w-10 h-10 flex items-center justify-center">
            <i className="ri-arrow-right-line text-2xl text-gray-800"></i>
          </Link>
          <h2 className="text-lg font-bold text-gray-800">طلباتي</h2>
          <div className="w-10"></div>
        </div>

        {/* Tabs */}
        <div className="px-4 pb-3 overflow-x-auto scrollbar-hide">
          <div className="flex gap-2">
            <button
              onClick={() => setActiveTab('all')}
              className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-300 ${
                activeTab === 'all'
                  ? 'bg-gradient-to-r from-blue-500 to-purple-500 text-white shadow-lg'
                  : 'bg-gray-100 text-gray-700'
              }`}
            >
              الكل ({orders.length})
            </button>
            <button
              onClick={() => setActiveTab('processing')}
              className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-300 ${
                activeTab === 'processing'
                  ? 'bg-gradient-to-r from-blue-500 to-purple-500 text-white shadow-lg'
                  : 'bg-gray-100 text-gray-700'
              }`}
            >
              قيد المعالجة
            </button>
            <button
              onClick={() => setActiveTab('shipping')}
              className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-300 ${
                activeTab === 'shipping'
                  ? 'bg-gradient-to-r from-blue-500 to-purple-500 text-white shadow-lg'
                  : 'bg-gray-100 text-gray-700'
              }`}
            >
              قيد الشحن
            </button>
            <button
              onClick={() => setActiveTab('delivered')}
              className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-300 ${
                activeTab === 'delivered'
                  ? 'bg-gradient-to-r from-blue-500 to-purple-500 text-white shadow-lg'
                  : 'bg-gray-100 text-gray-700'
              }`}
            >
              مكتمل
            </button>
          </div>
        </div>
      </div>

      {/* Orders List */}
      <div className="pt-32 px-4">
        {filteredOrders.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-20">
            <div className="w-32 h-32 bg-gradient-to-br from-blue-100 to-purple-100 rounded-full flex items-center justify-center mb-6">
              <i className="ri-shopping-bag-line text-6xl text-blue-500"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-2">لا توجد طلبات</h3>
            <p className="text-gray-600 mb-6">لم تقم بأي طلبات بعد</p>
            <Link
              to="/"
              className="px-8 py-3 bg-gradient-to-r from-blue-500 to-purple-500 text-white rounded-2xl font-bold shadow-lg"
            >
              ابدأ التسوق
            </Link>
          </div>
        ) : (
          <div className="space-y-4">
            {filteredOrders.map((order) => {
              const statusInfo = getStatusInfo(order.status);
              return (
                <Link
                  key={order.id}
                  to={`/order/${order.id}`}
                  className="bg-white rounded-2xl p-4 shadow-sm hover:shadow-lg transition-all duration-300"
                >
                  <div className="flex items-start gap-4 mb-3">
                    <div className="w-20 h-20 bg-gray-100 rounded-xl overflow-hidden flex-shrink-0">
                      <img
                        src={order.image}
                        alt="Order"
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                    <div className="flex-1">
                      <div className="flex items-start justify-between mb-2">
                        <div>
                          <p className="text-sm font-bold text-gray-800">{order.id}</p>
                          <p className="text-xs text-gray-500">{order.date}</p>
                        </div>
                        <div className={`px-3 py-1 rounded-full ${statusInfo.bg} flex items-center gap-1`}>
                          <i className={`${statusInfo.icon} ${statusInfo.color} text-sm`}></i>
                          <span className={`text-xs font-bold ${statusInfo.color}`}>{statusInfo.text}</span>
                        </div>
                      </div>
                      <p className="text-xs text-gray-600 mb-2">{order.items} منتجات</p>
                      <div className="flex items-center justify-between">
                        <span className="text-lg font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                          {order.total} ر.س
                        </span>
                        <button className="text-blue-600 text-sm font-medium flex items-center gap-1">
                          التفاصيل
                          <i className="ri-arrow-left-s-line"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  
                  {order.status === 'delivered' && (
                    <div className="border-t border-gray-100 pt-3 flex gap-2">
                      <button className="flex-1 py-2 bg-gradient-to-r from-blue-500 to-purple-500 text-white rounded-xl text-sm font-bold">
                        إعادة الطلب
                      </button>
                      <button className="flex-1 py-2 bg-gray-100 text-gray-700 rounded-xl text-sm font-bold">
                        تقييم المنتج
                      </button>
                    </div>
                  )}
                  
                  {order.status === 'shipping' && (
                    <div className="border-t border-gray-100 pt-3">
                      <button className="w-full py-2 bg-gradient-to-r from-blue-500 to-purple-500 text-white rounded-xl text-sm font-bold flex items-center justify-center gap-2">
                        <i className="ri-map-pin-line"></i>
                        تتبع الشحنة
                      </button>
                    </div>
                  )}
                </Link>
              );
            })}
          </div>
        )}
      </div>

      {/* Bottom Navigation */}
      <nav className="fixed bottom-0 w-full bg-white shadow-lg border-t border-gray-100 z-50">
        <div className="grid grid-cols-5 h-16">
          <Link to="/" className="flex flex-col items-center justify-center gap-1 text-gray-400 hover:text-gray-600 transition-colors">
            <i className="ri-home-line text-xl"></i>
            <span className="text-xs">الرئيسية</span>
          </Link>
          <Link to="/explore" className="flex flex-col items-center justify-center gap-1 text-gray-400 hover:text-gray-600 transition-colors">
            <i className="ri-search-line text-xl"></i>
            <span className="text-xs">استكشف</span>
          </Link>
          <Link to="/cart" className="flex flex-col items-center justify-center gap-1 text-gray-400 hover:text-gray-600 transition-colors relative">
            <i className="ri-shopping-cart-line text-xl"></i>
            <span className="text-xs">السلة</span>
            <span className="absolute top-1 right-1/2 translate-x-3 w-5 h-5 bg-gradient-to-r from-red-500 to-pink-500 text-white text-xs font-bold rounded-full flex items-center justify-center">3</span>
          </Link>
          <Link to="/favorites" className="flex flex-col items-center justify-center gap-1 text-gray-400 hover:text-gray-600 transition-colors">
            <i className="ri-heart-line text-xl"></i>
            <span className="text-xs">المفضلة</span>
          </Link>
          <Link to="/profile" className="flex flex-col items-center justify-center gap-1 text-gray-400 hover:text-gray-600 transition-colors">
            <i className="ri-user-line text-xl"></i>
            <span className="text-xs">حسابي</span>
          </Link>
        </div>
      </nav>
    </div>
  );
}
